import React, { useContext, useEffect, useState } from 'react';

import alertTokens from '@amzn/meridian-tokens/base/icon/alert';
import Icon from '@amzn/meridian/icon';
import Tooltip from '@amzn/meridian/tooltip';

import { ICellRendererParams } from 'ag-grid-community';
import { AddDealContext } from 'src/contexts/addDealContext';

import './VendorCellRenderer.scss';

export const VendorCellRenderer = (props: ICellRendererParams) => {
    const { specifyDealGridRowErrorStates } = useContext(AddDealContext);

    const [hasError, setHasError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    useEffect(() => {
        const rowIndex = props.node.rowIndex;

        if (specifyDealGridRowErrorStates[rowIndex!].hasError) {
            setHasError(true);
            setErrorMsg(specifyDealGridRowErrorStates[rowIndex!].errorMsg);
        } else {
            setHasError(false);
            setErrorMsg('');
        }
    }, [specifyDealGridRowErrorStates]);

    return (
        <span>
            {hasError && (
                <>
                    <Tooltip position="bottom" title={errorMsg}>
                        <Icon className="alert-token" tokens={alertTokens} />
                    </Tooltip>
                </>
            )}
            {props.value}
        </span>
    );
};
